import React from "react";
import { MenuItem, Select, FormControl } from "@mui/material";
import Text from "../../../utils/Custom/text";
import { HSE_CHECK_POINTS } from "./generalIRConst";

// value mapping: 1 = NA, 2 = Ok, 3 = Not Ok
export const HSE_OPTIONS_LABEL = [
  { label: "Select", value: 0 },
  { label: "NA", value: 1 },
  { label: "Yes", value: 2 },
  { label: "No", value: 3 },
];

const HseCheckPoints = ({ data, onChange, PrintView }) => {
  // split into two columns
  const left = HSE_CHECK_POINTS.filter((_, i) => i % 2 === 0);
  const right = HSE_CHECK_POINTS.filter((_, i) => i % 2 !== 0);
  const rows = left.map((l, i) => ({ left: l, right: right[i] }));

  const renderSelect = (point) => (
  <FormControl size="small" fullWidth disabled={PrintView}>
    <Select
      value={data[point.key] ?? 0}
      onChange={(e) => onChange(point.key, e.target.value)}
      displayEmpty
      renderValue={(val) => {
        const found = HSE_OPTIONS_LABEL.find((o) => o.value === val);
        return (
          <span style={{ color: val === 0 ? "#9ca3af" : "inherit" }}>
            {found ? found.label : "Select"}
          </span>
        );
      }}
      sx={{ backgroundColor: "#fff", fontSize: "0.875rem" }}
    >
      {HSE_OPTIONS_LABEL.map((opt) => (
        <MenuItem key={opt.value} value={opt.value} disabled={opt.value === 0}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

  return (
    <>
      <Text variant="h6" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
        14. HSE check points: <span className="font-normal text-xs">(Write Yes / No / NA as applicable)</span>
      </Text>

      <div className="border border-gray-400 overflow-x-auto">
        <table className="w-full text-sm border-collapse min-w-[600px]">
          <tbody>
            {rows.map((row, i) => (
              <tr key={i} className="border-t border-gray-400">
                {/* left question */}
                <td className="px-3 py-2 border-r border-gray-400 w-[35%] align-middle">
                  {row.left.label}
                </td>
                {/* left answer */}
                <td className="px-3 py-2 border-r border-gray-400 w-[15%] align-middle">
                  {renderSelect(row.left)}
                </td>
                {/* right question */}
                <td className="px-3 py-2 border-r border-gray-400 w-[35%] align-middle">
                  {row.right ? row.right.label : ""}
                </td>
                {/* right answer */}
                <td className="px-3 py-2 w-[15%] align-middle">
                  {row.right ? renderSelect(row.right) : ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default HseCheckPoints;